import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ScopeofServicesComponent.metadata.json5';

import styles from '../ITProfessional.module.scss';
import ProductsorServicesComponent from '../subcomponents/ProductsorServices/ProductsorServicesComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ScopeofServicesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ScopeofServicesComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        productsorServicesComponent: {
            data: modelVM.subScopeofServicesDTO,
            updateWizardData,
            submissionVM,
            ProductsorServicesPath: `${pathUpdated}.subScopeofServicesDTO`
        },
        webhostingTitle: {
            visible: !_.isUndefined(_.find(modelVM.value.subScopeofServicesDTO, (subScopeofServiceDTO) => subScopeofServiceDTO.natOfWor1 === 'WebHosSer')),
        },
        doeTheAppHosWebOnIts10: {
            visible: !_.isUndefined(_.find(modelVM.value.subScopeofServicesDTO, (subScopeofServiceDTO) => subScopeofServiceDTO.natOfWor1 === 'WebHosSer')),
            required: !_.isUndefined(_.find(modelVM.value.subScopeofServicesDTO, (subScopeofServiceDTO) => subScopeofServiceDTO.natOfWor1 === 'WebHosSer'))
        },
        aIsTheRedInTheSer11: {
            visible: !_.isUndefined(modelVM.value.doeTheAppHosWebOnIts10) && modelVM.value.doeTheAppHosWebOnIts10
        },
        bIsDatBacUpOnA12: {
            visible: !_.isUndefined(modelVM.value.doeTheAppHosWebOnIts10) && modelVM.value.doeTheAppHosWebOnIts10
        },
        totalPer2: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'per2')))
        },
        totalActRevForExpTerCdn3: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: { amount: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'actRevForExpTerCdn3.amount'))), currency: 'CAD' }
        },
        totalActRevForExpTerUs4: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: { amount: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'actRevForExpTerUs4.amount'))), currency: 'CAD' }
        },
        totalActRevForExpTerFor5: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: { amount: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'actRevForExpTerFor5.amount'))), currency: 'CAD' }
        },
        totalEstAnnRevNex12MonCdn6: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: { amount: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'estAnnRevNex12MonCdn6.amount'))), currency: 'CAD' }
        },
        totalEstAnnRevNex12MonUs7: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: { amount: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'estAnnRevNex12MonUs7.amount'))), currency: 'CAD' }
        },
        totalEstAnnRevNex12MonFor8: {
            visible: modelVM.subScopeofServicesDTO.value.length > 0,
            value: { amount: _.sumBy(modelVM.value.subScopeofServicesDTO, (subScopeofService) => Number(_.get(subScopeofService, 'estAnnRevNex12MonFor8.amount'))), currency: 'CAD' }
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productsorServicesComponent: ProductsorServicesComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ScopeofServicesComponent.propTypes = wizardProps;
export default withRouter(ScopeofServicesComponent);
